function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.87066708,6.41017507 L7.87066708,5.02798117 C7.87066708,2.9847374 6.53219326,1.60254375 4.59653417,1.60254375 C3.19626715,1.60254375 2.08428327,2.30365658 1.61065885,3.54562827 C1.44592381,3.96629616 0.972273857,4.16661405 0.539849158,4.00635961 C0.107424459,3.84610517 -0.0984847695,3.38537383 0.045656797,2.96470594 C0.786958106,1.12178056 2.51672074,0 4.61711488,0 C7.50001004,0 9.51806858,2.06327513 9.51806858,5.02798117 L9.51806858,6.41017507 L7.87066708,6.41017507 Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M17.161266,6.2711114 C8.317977,6.2711114 9.255745,6.2711114 5.838721,6.2711114 C5.377416,6.2711114 5,6.63511166 5,7.08000052 L5,17.1911127 C5,17.6360016 5.377416,18 5.838721,18 L17.161266,18 C17.622584,18 18,17.6360016 18,17.1911127 L18,7.08000052 C18,6.63511166 17.622584,6.2711114 17.161266,6.2711114 Z M16.322545,16.3822229 L6.677416,16.3822229 L6.677416,7.88888964 L16.322545,7.88888964 L16.322545,16.3822229 Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 5,
  x: 11,
  y: 10,
  rx: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 1.5
}));

function SvgIconUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon_unlock.4c0b2916.svg";
export { ForwardRef as ReactComponent };